import { useGraphQLQuery } from '@betterment/js-runtime';
import { ErrorBoundary } from '@betterment/shared-components';
import { NavLink } from 'react-router-dom';

import { SidebarEmployersDocument } from './graphql/query.sidebarEmployers.generated';

import { Nav } from '../../../Shared/components-v2/nav/nav';
import { navItemStyles } from '../../../Shared/components-v2/nav/nav-link-styles';
import { useProcessNavTransition } from '../../hooks/useProcessNavTransition';

const EmployerNavLinkView: React.FC = () => {
  const processNavTransition = useProcessNavTransition();
  const { data } = useGraphQLQuery(SidebarEmployersDocument, {
    fetchPolicy: 'cache-first',
  });

  if (!data?.employers || data.employers.length === 0) return null;

  return (
    <NavLink to="/employee_benefits/active_benefits" className={navItemStyles()} onClick={processNavTransition}>
      <Nav.Icon name="CharityHand" />
      <Nav.Text>Employee benefits</Nav.Text>
    </NavLink>
  );
};

export const EmployerNavLink = () => {
  return (
    <ErrorBoundary fallbackType="inline" feature="sidebar" owner="user_engagement">
      <EmployerNavLinkView />
    </ErrorBoundary>
  );
};
